import type { TableColumnDescriptor } from '@finance/contracts';

export interface ColumnSizingStyle {
  width?: number;
  minWidth: number;
  maxWidth?: number;
}

export function resolveColumnSizing(
  column: TableColumnDescriptor,
  resolvedWidth?: number,
): ColumnSizingStyle {
  const sizingMode = column.sizingMode ?? (column.maxWidth ? 'bounded' : 'flexible');
  const minWidth = column.minWidth ?? 80;

  if (sizingMode === 'fixed') {
    const width = resolvedWidth ?? column.defaultWidth ?? minWidth;
    return {
      width,
      minWidth: width,
      maxWidth: width,
    };
  }

  if (sizingMode === 'bounded') {
    const width = resolvedWidth ?? column.defaultWidth;
    return {
      width,
      minWidth,
      maxWidth: column.maxWidth ?? width,
    };
  }

  return {
    width: resolvedWidth,
    minWidth,
    maxWidth: column.maxWidth,
  };
}

export function getColumnIntrinsicMinWidth(
  column: TableColumnDescriptor,
  resolvedWidth?: number,
): number {
  const sizing = resolveColumnSizing(column, resolvedWidth);
  return sizing.width ?? sizing.minWidth;
}
